import React from 'react';
import log from 'loglevel';
import {
	Button,
	Checkbox,
	Grid,
	GridItem,
	Input,
	RadioButton,
	TextField,
} from '../../../ui';
// eslint-disable-next-line no-restricted-imports
import { useForm } from 'react-hook-form';

interface IFormData {
	someField: string;
	anotherField: string;
	yetAnotherField: string;
	radio: string;
	someCheckbox: string;
	anotherCheckbox: string;
	aDisabledField: string;
	aDisabledRadioButton: string;
	aCheckedDisabledRadioButton: string;
	aDisabledCheckbox: string;
	aCheckedDisabledCheckbox: string;
}

interface IFormProps {
	onSubmit?: (data: IFormData) => void | Promise<void>;
}

export const Form = ({ onSubmit }: IFormProps) => {
	const {
		handleSubmit,
		register,
		formState: { errors, isValid, isDirty },
	} = useForm<IFormData>({
		mode: 'onSubmit',
	});

	log.debug('Is form valid:', isValid);
	log.debug('Is form dirty:', isDirty);

	const innerOnSubmit = handleSubmit(async (data: IFormData) => {
		log.info('Submitted', data);

		if (onSubmit) {
			await onSubmit(data);
		}
	});

	return (
		<>
			<h2 id="form">Form</h2>
			<h3>Text fields</h3>
			<form onSubmit={innerOnSubmit} data-testid="form">
				<Grid>
					<GridItem columns={[4, { mobileXL: 12 }]}>
						<TextField
							label="Some field (required)"
							placeholder="Some placeholder text"
							error={errors.someField?.message}
							{...register('someField', { required: 'This field is required' })}
						/>
					</GridItem>
					<GridItem columns={[4, { mobileXL: 12 }]}>
						<TextField
							label="Another field (optional)"
							placeholder="Some placeholder text"
							error={errors.anotherField?.message}
							{...register('anotherField')}
						/>
					</GridItem>
					<GridItem columns={[4, { mobileXL: 12 }]}>
						<TextField
							label="Another field (optional)"
							placeholder="Some placeholder text"
							warning="Some warning message"
							{...register('yetAnotherField')}
						/>
					</GridItem>
					<GridItem columns={[6, { mobileXL: 12 }]}>
						<TextField
							ariaLabel="Some aria label"
							placeholder="Another optional text field, but without label (aria-only)"
							{...register('yetAnotherField')}
						/>
					</GridItem>
					<GridItem columns={[6, { mobileXL: 12 }]}>
						<TextField
							ariaLabel="Some aria label"
							placeholder="A disabled field, without label"
							disabled
							{...register('aDisabledField')}
						/>
					</GridItem>
					<GridItem columns={[6, { mobileXL: 12 }]}>
						<Input placeholder="A field, with placeholder as label" />
					</GridItem>

					<GridItem columns={[3, { mobileXL: 6, mobile: 12 }]}>
						<RadioButton
							value="1"
							label="Some radio button"
							{...register('radio')}
						/>
					</GridItem>
					<GridItem columns={[3, { mobileXL: 6, mobile: 12 }]}>
						<RadioButton
							value="2"
							label="Another radio button"
							{...register('radio')}
						/>
					</GridItem>
					<GridItem columns={[3, { mobileXL: 6, mobile: 12 }]}>
						<Checkbox
							label="Some checkbox (required)"
							{...register('someCheckbox', {
								required: 'This field is required',
							})}
						/>
					</GridItem>
					<GridItem columns={[3, { mobileXL: 6, mobile: 12 }]}>
						<Checkbox
							label="Another checkbox (optional)"
							{...register('anotherCheckbox')}
						/>
					</GridItem>
					<GridItem columns={[3, { mobileXL: 6, mobile: 12 }]}>
						<RadioButton
							label="Disabled"
							disabled
							{...register('aDisabledRadioButton')}
						/>
					</GridItem>
					<GridItem columns={[3, { mobileXL: 6, mobile: 12 }]}>
						<RadioButton
							label="Checked & disabled"
							checked
							disabled
							{...register('aCheckedDisabledRadioButton')}
						/>
					</GridItem>
					<GridItem columns={[3, { mobileXL: 6, mobile: 12 }]}>
						<Checkbox
							label="Disabled"
							disabled
							{...register('aDisabledCheckbox')}
						/>
					</GridItem>
					<GridItem columns={[3, { mobileXL: 6, mobile: 12 }]}>
						<Checkbox
							label="Checked & Disabled"
							checked
							disabled
							{...register('aCheckedDisabledCheckbox')}
						/>
					</GridItem>
					<GridItem columns={12}>
						<Button disabled={!isValid || !isDirty} type="submit">
							Submit
						</Button>
					</GridItem>
				</Grid>
			</form>
		</>
	);
};
